import { Globe } from 'icons/Globe';
import * as S from './GeolocationLabelStyles';
import { ARTICLE_PAGE_TEST_IDS } from '@/main/constants/testsIds/articlePage';

export interface GeolocationLabelProps {
  title: string;
  href: string;
}

const GeolocationLabel = ({ title, href }: GeolocationLabelProps) => (
  <S.Wrapper
    href={href}
    data-cy={ARTICLE_PAGE_TEST_IDS.GEO_LOCATION_LABEL}
  >
    <Globe />
    <S.Title>{title}</S.Title>
  </S.Wrapper>
);

export default GeolocationLabel;
